import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";

const NewsUploadMedia = () => {
    // context
    const {
        newsMedia,
        setNewsMedia,
        newsCover,
        setNewsCover,
        setNewsCoverId,
        newsMediaId,
        setNewsMediaId,
        newsCoverId,
    } = useContext(context);

    // useEffect
    useEffect(() => {
        setNewsCoverId(newsCover[0] ? newsCover[0]._id : null);
        const ids = [];
        const files = [];
        newsMedia.map((file) => {
            ids.push(file._id);
            files.push({
                uid: file._id,
                name: `${file.type}/${file._id}`,
                status: "done",
                url: file.address,
            });
        });
        setNewsMediaId(ids);
        setNewsMedia(files);
        setNewsCover([
            {
                uid: newsCoverId,
                name: "image.png",
                status: "done",
                url: newsCover[0]?.address,
            },
        ]);
    }, []);
    // upload
    const onChangeCover = (info) => {
        setNewsCover(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            setNewsCoverId(info.file.response.files[0]._id);
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onChange = (info) => {
        setNewsMedia(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            info.file.response.files.map((file) => {
                setNewsMediaId([...newsMediaId, file._id]);
            });
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    const handleRemove = (info) => {
        const newFiles = newsMedia.filter((file) => file !== info);
        const newIds = newsMediaId.filter((id) => id !== info.uid);
        setNewsMediaId(newIds);
        setNewsMedia(newFiles);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "2rem 0",
                gap: "2rem",
            }}
        >
            <ImgCrop modalTitle="ویرایش عکس" aspect={2} rotationSlider>
                <Upload
                    maxCount={1}
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b63df1a473d24d7c455306`}
                    listType="picture-card"
                    fileList={newsCover}
                    onChange={onChangeCover}
                    onPreview={onPreview}
                >
                    {newsCover.length < 5 && "+ آپلود عکس کاور"}
                </Upload>
            </ImgCrop>
            <ImgCrop modalTitle="ویرایش عکس" rotationSlider>
                <Upload
                    accept="image/*"
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b63dfda473d24d7c455336`}
                    listType="picture-card"
                    fileList={newsMedia}
                    onChange={onChange}
                    onPreview={onPreview}
                    onRemove={handleRemove}
                >
                    {newsCover.length < 3 && "+ آپلود عکس"}
                </Upload>
            </ImgCrop>
            <Upload
                accept="video/*"
                multiple={false}
                name="objectKey"
                action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b63dfda473d24d7c455336`}
                listType="picture-card"
                fileList={newsMedia}
                onChange={onChange}
                onPreview={onPreview}
                onRemove={handleRemove}
            >
                {newsCover.length < 3 && "+ آپلود ویدیو"}
            </Upload>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    flexWrap: "wrap",
                    gap: "2rem",
                }}
            >
                {newsMedia.map((media) => {
                    if (media.name && media.name.slice(0, 5) === "video") {
                        return (
                            <video
                                src={media.url}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    } else if (
                        media.type &&
                        media.type.slice(0, 5) === "video"
                    ) {
                        return (
                            <video
                                src={media.response?.files[0].address}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default NewsUploadMedia;
